import Holidays from 'date-holidays'

/** Trạng thái “thiếu / vắng” — trên ngày nghỉ lịch thì không xuất ra Excel (để trống). */
const FAULT_STATUS_KEYS = new Set<string>([
  'MISSING_TIME',
  'MISSING',
  'MORNING_MISSING',
  'AFTERNOON_MISSING',
  'MORNING_MISSING_PAID',
  'AFTERNOON_MISSING_PAID',
  'ABSENT',
  'MORNING_ABSENT',
  'AFTERNOON_ABSENT',
])

let vnHolidays: Holidays | null = null

function getVnHolidays(): Holidays {
  if (!vnHolidays) {
    vnHolidays = new Holidays('VN', {
      timezone: 'Asia/Ho_Chi_Minh',
      languages: 'vi',
      types: ['public'],
    })
  }
  return vnHolidays
}

/** Chủ nhật cả ngày + chiều thứ bảy (giống quy ước trên UI chấm công). */
export function isFixedWeeklyRestShift(
  year: number,
  month: number,
  day: number,
  shift: 'am' | 'pm',
): boolean {
  const date = new Date(year, month - 1, day)
  const dow = date.getDay()
  if (dow === 0) return true
  if (dow === 6 && shift === 'pm') return true
  return false
}

export function isVietnamPublicHolidayDate(year: number, month: number, day: number): boolean {
  const list = getVnHolidays().isHoliday(new Date(year, month - 1, day))
  return Array.isArray(list) && list.length > 0
}

/** Ca đó được coi là nghỉ khi xuất Excel: T7 chiều, CN, hoặc ngày lễ quốc gia VN (theo thư viện date-holidays). */
export function isExportRestShift(
  year: number,
  month: number,
  day: number,
  shift: 'am' | 'pm',
): boolean {
  if (isFixedWeeklyRestShift(year, month, day, shift)) return true
  if (isVietnamPublicHolidayDate(year, month, day)) return true
  return false
}

export function isFaultAttendanceForRestExport(val: string | number | null | undefined): boolean {
  if (val === null || val === undefined || val === '' || val === 0 || val === 'NONE') return false
  if (val === 2 || val === 4) return true
  return FAULT_STATUS_KEYS.has(String(val))
}
